import { BrowserRouter as Router, Routes, Route, Navigate, Outlet, useParams } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import Layout from "./container/Layout";
import { Home } from "./pages/Home";
import { School } from "./pages/School";
import { Nosotros } from "./pages/Nosotros";
import { Bancos } from "./pages/Bancos";
import { CajerosAutomaticos } from "./pages/CajerosAutomaticos";
import { Contactenos } from "./pages/Contactenos";
import { Servicios } from "./pages/Servicios";
import { Retail } from "./pages/Retail";
import SeccionBlog from "./components/Blog/SeccionBlog";
import { BlogDetail } from "./pages/BlogDetail";

const SUPPORTED_LANGS = ["es", "en"];
const DEFAULT_LANG = "en";

function LangGate() {
  const { i18n } = useTranslation();
  const { lang } = useParams();

  useEffect(() => {
    const current = SUPPORTED_LANGS.includes(lang) ? lang : DEFAULT_LANG;
    if (i18n.language !== current) i18n.changeLanguage(current);
  }, [lang, i18n]);

  if (!SUPPORTED_LANGS.includes(lang)) {
    return <Navigate to={`/${DEFAULT_LANG}`} replace />;
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          {/* Raíz: redirige al idioma por defecto */}
          <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />

          <Route path="/:lang" element={<LangGate />}>
            <Route index element={<Home />} />

            {/* ES */}
            <Route path="nosotros" element={<Nosotros />} />
            <Route path="bancos" element={<Bancos />} />
            <Route path="retail" element={<Retail />} />
            <Route path="cajerosautomaticos" element={<CajerosAutomaticos />} />
            <Route path="servicios" element={<Servicios />} />
            <Route path="contactenos" element={<Contactenos />} />
            <Route path="school" element={<School />} />
            <Route path="blog" element={<SeccionBlog />} />
            <Route path="blog/:slug" element={<BlogDetail />} />

            {/* EN equivalentes */}
            <Route path="about-us" element={<Nosotros />} />
            <Route path="banks" element={<Bancos />} />
            <Route path="retail" element={<Retail />} />
            <Route path="atms" element={<CajerosAutomaticos />} />
            <Route path="services" element={<Servicios />} />
            <Route path="contact" element={<Contactenos />} />
            <Route path="school" element={<School />} />
            <Route path="blog" element={<SeccionBlog />} />
            <Route path="blog/:slug" element={<BlogDetail />} />
          </Route>

          <Route path="*" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}
